import styled from 'styled-components';

import pageIcon from '../../assets/images/page.png';

const StyledLi = styled.li`
	position: relative;
	width: 100%;
	height: 25px;
	list-style: none;

	a {
		position: absolute;
		display: flex;
		align-items: center;
		height: 100%;
		padding: 4px;
		column-gap: 6px;
		text-decoration: none;
		cursor: pointer;
	}
`;

const StyledFileImg = styled.img.attrs({
	src: pageIcon,
})`
	width: 20px;
	height: 20px;
`;

const StyledTextSpan = styled.span`
	font-family: 'Helvetica Neue', 'Lucida Grande', 'Arial';
	font-size: 13px;
	color: #555;
`;

export { StyledFileImg, StyledLi, StyledTextSpan };
